
import { css } from 'lit';
export default css`
.cta-breaker {
  background-color: #6B1F99;
  padding: 60px 0;
  position: relative;
  width: 100vw;
  max-width: 1440px;
  left: 50%;
  transform: translateX(-50%);
}
  
  .cta-breaker__container {
    width: calc(100% - 30px);
    max-width: 1250px;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
  }
  
  @media (min-width: 640px) {
  
  .cta-breaker__container {
      width: calc(100% - 50px)
  }
    }
  
  @media (min-width: 768px) {
  
  .cta-breaker__container {
      width: calc(100% - 100px)
  }
    }
  
  @media (min-width: 1024px) {
  
  .cta-breaker__container {
      flex-direction: row
  }
    }
  
  .cta-breaker__left {
    color: white;
    width: 100%;

    
    
  }
  
  @media (min-width: 1024px) {
  
  .cta-breaker__left {
      width: 67%

    
    
  }
    }
  
  .cta-breaker__right {
    width: 100%;
    display: flex;
    align-items: center;
  }
  
  @media (min-width: 1024px) {
  
  .cta-breaker__right {
      width: 33%
  }
    }
  
  .cta-breaker__heading {
    font-family: Lato, sans-serif;
    color: #FFF;
    font-size: 29px;
    font-style: normal;
    font-weight: 700;
    line-height: 129%; /* 43.86px */
    letter-spacing: 0.34px;
  }
  
  .cta-breaker__links {
    width: 100%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    gap: 15px;
  }
  
  @media (min-width: 768px) {
  
  .cta-breaker__links {
      width: -webkit-max-content;
      width: -moz-max-content;
      width: max-content
  }
    }
  
  .cta-breaker__links a {
      border: solid 2px white;
      display: block;
      padding: 15px 25px;
      color: white;
      width: 100%;
      font-size: 20px;
      font-weight: bold;
      text-align: center;
    }
  
  @media (min-width: 768px) {
  
  .cta-breaker__links a {
        text-align: left;
        width: -webkit-max-content;
        width: -moz-max-content;
        width: max-content
    }
      }
`;